<template>
  <div>
    <autocomplete
      v-model="localValue"
      :get-list="getList"
      label="Фактический адрес проживания"
      :required-mark="field.required"
      :invalid="!!error"
      :error="error"
    />
  </div>
</template>

<script>
import Autocomplete from "@/components/controls2/Autocomplete";
import {getAddresses} from "@/utils/api/kladr";

export default {
  components: { Autocomplete },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },

  watch: {
    localValue(v) {
      if (this.value === v) return;
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    async getList(query) {
      const token = this.$store.getters.getAuthToken;
      const list = await getAddresses(query, token);
      return list.map((item) => ({ id: item.id, text: item.value }));
    },
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = value.value || "";
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>
